// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tooltipZIndex":"3","tooltipSpacing":"10px","caretIcon":"PFQ3s-WQpNpX","isUp":"IyeNGC+mYsAb"};